import createRoute   from '@widesk-ui/tools/createRoute';
import SitePageModel from '@models/admin/SitePageModel';

export default createRoute.table(
	SitePageModel.pagePath('list'),
	SitePageModel.serviceName,
	'SitePageTable',
	SitePageModel.localize('plural'),
);